import ShiftCalendarItemAssigned from './Assigned';

export default ShiftCalendarItemAssigned;
